export const excludedPaths = ['/admin', '/profiles']
